<template>
  <div class="team-calendar-list">
    <v-card
      v-if="events.length > 0"
      class="team-calendar-list-month"
      ref="eventList"
    >
      <div class="flex flex-row justify-center text-center pb-3">
        <v-btn
          v-if="isCurrentMonth && pastEvents && !showPastEvents"
          @click="toggleShowPastEvents"
          class="show-past-events"
          text
          color="primary"
        >
          Show events from earlier this month.
        </v-btn>
      </div>
      <TeamCalendarEventRow
        v-for="event in events"
        :key="event.id"
        :event="event"
        :teamId="teamId"
        :ref="event.start"
        v-if="
          !isCurrentMonth ||
            event.start >= Date.now() ||
            (isCurrentMonth && showPastEvents)
        "
      />
    </v-card>
    <div class="no-events" v-else-if="loadingCount == 0">
      No events for current selection
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import TeamCalendarEventRow from "@/components/TeamCalendar/TeamCalendarEventRow.vue";

export default Vue.extend({
  name: "TeamCalendarList",
  components: { TeamCalendarEventRow },
  props: {
    events: {
      type: Array
    },
    teamId: {
      type: String
    },
    loadingCount: {
      type: Number
    },
    month: {
      type: Date
    }
  },
  data() {
    return {
      showPastEvents: false
    };
  },
  mounted() {
    console.log(`the component is now mounted.`);
  },
  computed: {
    pastEvents() {
      let pastEvents = false;
      this.events.forEach(event => {
        if (event.start < Date.now()) {
          pastEvents = true;
        }
      });
      return pastEvents;
    },
    isCurrentMonth() {
      const today = new Date();
      return (
        this.month &&
        this.month.getFullYear() === today.getFullYear() &&
        this.month.getMonth() === today.getMonth()
      );
    }
  },
  methods: {
    toggleShowPastEvents() {
      this.showPastEvents = !this.showPastEvents;
    }
  },
  watch: {
    month() {
      console.log("Month changed!");
      this.showPastEvents = false;
    }
  }
});
</script>
<style scoped>
.no-events {
  font-size: 18px;
  text-align: center;
  margin-top: 40px;
  opacity: 0.5;
}

.event-date-time {
  font-size: 20px;
  font-weight: 500;
  color: black;
  text-transform: uppercase;
}

.event-date-time small {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  margin-left: 5px;
}

.show-past-events {
  padding-bottom: 10px;
  text-align: center;
}
</style>
